import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    TextField
} from "@mui/material";
import {CompanyCreateDto} from "../entities/company-create-dto";
import {useState} from "react";
import {DateTime} from "luxon"
import {DatePicker} from "@mui/x-date-pickers";

export interface CompanyCreateDialogProps {
    isOpen: boolean;
    onClose: (companyCreateDTO?: CompanyCreateDto) => void;
}

export const CompanyCreateDialog = ({isOpen, onClose}: CompanyCreateDialogProps) => {

    const [companyName, setCompanyName] = useState("")
    const [tokenManagerEmail, setTokenManagerEmail] = useState("")
    const [tokenReseller, setTokenReseller] = useState(false)
    const [expirationDate, setExpirationDate] = useState<DateTime>(DateTime.now().toUTC().startOf('day').plus({year: 1}))

    const submitForm = () => {
        onClose({companyName, renewalDate: expirationDate.toISO()!!, tokenManagerEmail, tokenReseller})
    }

    return (<Dialog open={isOpen} onClose={() => onClose()}>
        <DialogTitle title="Add Company">Add Company</DialogTitle>
        <DialogContent>
            <form>
                <TextField value={companyName} placeholder="Company name" name="companyName"
                           label="Company name" fullWidth sx={{marginTop: "1rem"}} required
                           onChange={(ev) => setCompanyName(ev.target.value)}/>
                <FormControlLabel control={<Checkbox onChange={(ev) => setTokenReseller(ev.target.checked)} checked={tokenReseller}/>}
                                  label="Is the company a token reseller ?"/>
                <TextField value={tokenManagerEmail} placeholder="Token manager email" required type="email" name="tokenManagerEmail"
                           label="Token manager email" fullWidth sx={{marginTop: "1rem"}}
                           onChange={(ev) => setTokenManagerEmail(ev.target.value)}/>
                <DatePicker label="End of membership" value={expirationDate} sx={{marginTop: "1rem", "width": "100%"}}
                            onChange={(ev) => setExpirationDate(ev!!)}/>
            </form>

        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="success" disabled={!companyName || !tokenManagerEmail || !expirationDate}
                    onClick={() => submitForm()}>Create company</Button>
            <Button color="error" onClick={() => onClose()}>Cancel</Button>
        </DialogActions>
    </Dialog>)
}